import src from "IMAGE";
export default { src, width: 2000, height: 2000, blurWidth: 0, blurHeight: 0};
